import { defineMessages } from 'react-intl';

export const scope = 'app.containers.StatusLabels';

export default defineMessages({
  noLink: {
    id: `${scope}.noLink`,
    defaultMessage: '{label} does not have a link',
  },
  noVideos: {
    id: `${scope}.noVideos`,
    defaultMessage: 'No videos for {label}',
  },
  defaultError: {
    id: `${scope}.defaultError`,
    defaultMessage: 'There was an error with {label}',
  },
  cancelAndReschedule: {
    id: `${scope}.cancelAndReschedule`,
    defaultMessage:
      'Applicant has been notified of session cancellation and has been requested to reschedule',
  },
  requestReschedule: {
    id: `${scope}.requestReschedule`,
    defaultMessage: 'Applicant has been requested to reschedule',
  },
  rescheduledTooltip: {
    id: `${scope}.rescheduledTooltip`,
    defaultMessage: 'Rescheduled {count} times',
  },
  collapseStatusLabel: {
    id: `${scope}.collapseStatusLabel`,
    defaultMessage: 'Collapse',
  },
  expandStatusLabel: {
    id: `${scope}.expandStatusLabel`,
    defaultMessage: 'Show all {count}',
  },
  bgcValid: {
    id: `${scope}.bgcValid`,
    defaultMessage:
      'BGC valid: {count, plural, one {# day} other {# days}} left ({date})',
    description:
      'Replaces a partner pill/chip title with the days left before a reusable background check window closes and the day it closes',
  },
  bgcExpired: {
    id: `${scope}.bgcExpired`,
    defaultMessage: 'BGC expired on {date}',
    description:
      'Replaces a partner pill/chip title once its background check can no longer be reused',
  },
});
